<template>
	<section
		v-if="articles.length"
		id="author-recent-articles"
		class="content is-medium has-margin-top"
	>
		<div class="section-heading">
			<h2>Recent Content by this Author</h2>
		</div>

		<article
			v-for="article in articles"
			class="blurb-item blurb-item--compact"
		>
			<div class="mg-link-group">
				<h2 class="title is-4 has-no-margin-top mg-link-group__title">
					<a :href="article.link">{{ article.Title }}</a>
				</h2>
				<p class="subtitle">
					<!-- <span v-html="article.BlurbText"></span> -->

					<small class="blurb-item__meta">
						<span v-for="item in article.fullcontentproductsource">
							{{ productSources[item] }}
						</span>

						<span>{{ article.displayDate }}</span>

						<span v-if="article.FullContentPageCount">
							{{ article.FullContentPageCount }} pages
						</span>
					</small>
				</p>
				<!--
					<ul
						v-if="article.hasSummary || article.hasFull"
						class="blurb-item__ctas horizontal-list-divided"
					>
						<li
							v-if="article.hasSummary"
							class="mg-link-group__summary-link"
						>
							<a :href="'/content/summary/' + article.Link"
								>Summary</a
							>
						</li>
						<li v-if="article.hasFull" class="mg-link-group__full-link">
							<a :href="'/content/full/' + article.Link"
								>Full Content</a
							>
						</li>
					</ul>
				-->
			</div>
		</article>
	</section>
	<div v-else class="notification">No recent content.</div>
</template>

<script>
const months = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December'
];

export default {
	name: 'author-recent-articles',
	props: ['id'],
	data() {
		return {
			apiContentUrl: '/mxt/ArticleContentApi/GetContentsByAuthorId',
			articles: [],
			productSources: {}
		};
	},
	methods: {
		getSources() {
			return new Promise((resolve, reject) => {
				return this.$http
					.get('/api/default/hierarchy-taxa/product-sources')
					.then(
						response => {
							if (response.body) {
								response.body.value.forEach((item, index) => {
									this.productSources[item.Id] = item.Title;
								});
							}

							return resolve();
						},
						error => {
							console.log(
								'There was a problem getting the product sources'
							);
							console.log(error.statusText);

							return reject();
						}
					);
			});
		},
		getArticles() {
			let requestOptions = {
				params: {
					id: this.id,
          taken: 4
				}
			};

			return new Promise((resolve, reject) => {
				this.$http.get(this.apiContentUrl, requestOptions).then(
					response => {
						if (response.body) this.articles = response.body.value;

						this.articles.forEach(function(item, index) {
							const date = new Date(item.PublicationDate);
							item.displayDate = `${
								months[date.getMonth()]
							} ${date.getDate()}, ${date.getFullYear()}`;

							item.link = `/content/${item.Link}`;
						});

						return resolve();
					},
					error => {
						console.log(
							'There was a problem getting the authors articles'
						);
						console.log(error.statusText);

						return reject();
					}
				);
			});
		},
		init() {
			this.getSources().then(() => {
				this.getArticles();
			});
		}
	},
	created() {
		this.init();
	}
};
</script>



// WEBPACK FOOTER //
// assets/src/js/components/vue-components/author-recent-articles.vue